import React from 'react';
import { PlayerInfo } from './types';

interface PlayerSelectorProps {
  player: PlayerInfo;
  activePlayer: PlayerInfo;
  switchToPlayer: (player: PlayerInfo) => void;
}

const PlayerSelector: React.FC<PlayerSelectorProps> = ({ player, activePlayer, switchToPlayer }) => {
  return (
    <button
      key={player.id}
      className={`flex-shrink-0 flex flex-col items-center  ${player.id !== activePlayer.id ? 'opacity-60' : ''}`}
      onClick={() => switchToPlayer(player)}
    >
      <div className="relative">
        <img
          src={player.avatar || '/assets/images/fallback.jpg'}
          alt={player.name}
          className={`size-12 rounded-full object-cover`}
        />
      </div>
      <div className="mt-1 text-center">
        <div className={`text-xs font-medium line-clamp-1 text-center ${player.id !== activePlayer.id ? '' : 'font-semibold'}`}>{player.name}</div>
      </div>
      {/* Active player indicator */}
      {player.id === activePlayer.id && (
        <div className="border-t border-primary border-4 w-4/5 rounded-full mt-1">
        </div>
      )}
    </button>
  );
};

export default PlayerSelector;
